import GlassBrokenIcon from '@ordr-as/icons/GlassBrokenIcon';
import { MenuAction } from '@ordr-as/umami-react/context-menu';
import classNames from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import { FormattedMessage } from 'react-intl';
import { useCartStore } from '../../../../../context/cart/CartStore';
import useAccessControl from '../../../../../hooks/useAccessControl';
import { useCartIsBusy } from '../../../../../hooks/useCartIsBusy';

type WastageMenuItemProps = {
  setOpenWasteDialog: Dispatch<SetStateAction<boolean>>;
};

const WastageMenuItem = (props: WastageMenuItemProps) => {
  const { setOpenWasteDialog } = props;
  const { userCanDiscard } = useAccessControl();
  const cartIsEmpty = useCartStore((x) => x.cart.orderLines.length === 0);
  const cartIsBusy = useCartIsBusy();

  const isDisabled = cartIsBusy || cartIsEmpty;
  const textColor = classNames({
    'text-grey-dark': !userCanDiscard || isDisabled,
    'text-brand-black ': userCanDiscard && !isDisabled,
  });

  return (
    <MenuAction
      isDisabled={isDisabled}
      isRestricted={!userCanDiscard}
      onClick={() => setOpenWasteDialog(true)}
      className={classNames(
        'umami-context-menu-item bg-brand-white text-small text-brand-secondary rounded-full py-4 px-4 pr-8',
        { 'hover:cursor-not-allowed': isDisabled }
      )}
    >
      <div className={'flex text-base ' + textColor}>
        <GlassBrokenIcon className={'mr-2 mt-1'} />
        <span className="align-baseline">
          <FormattedMessage id="generic.wastage" />
        </span>
      </div>
    </MenuAction>
  );
};

export default WastageMenuItem;
